import ReactDOMClient from "react-dom/client";
import Router from "./routers/router";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import logo from "./assets/logo/logo.jpg";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { PaymentProvider } from "./context/payment-success-context";
import { ClerkProvider } from "@clerk/clerk-react";
import { useEffect } from "react";
import { initGTM } from "./analytics/gtm";
import { trackEvent } from "./analytics/events";

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const AppWrapper = () => {
  useEffect(() => {
    initGTM()
  }, [])

useEffect(() => {
  let fired25 = false;
  let fired50 = false;
  let fired75 = false;
  let fired100 = false;

  const handleScroll = () => {
    const scrollPercent =
      (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;

    if (scrollPercent > 25 && !fired25) {
      fired25 = true;
      trackEvent("scroll_25");
    }

    if (scrollPercent > 50 && !fired50) {
      fired50 = true;
      trackEvent("scroll_50");
    }

    if (scrollPercent > 75 && !fired75) {
      fired75 = true;
      trackEvent("scroll_75");
    }

    if (scrollPercent > 90 && !fired100) {
      fired100 = true;
      trackEvent("scroll_90");
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  return (
    <PaymentProvider>
      <ClerkProvider publishableKey={clerkPubKey}>
        <Router />
      </ClerkProvider>

      <FloatingWhatsApp
        phoneNumber="+447572519628"
        accountName="Teck Engineers"
        avatar={logo}
        notification={false}
      />
    </PaymentProvider>
  )
}

const root = ReactDOMClient.createRoot(
  document.getElementById("root") as HTMLDivElement
)

root.render(<AppWrapper />)

